import { Person } from '@kavrillon/tree-core';

interface IProps {
  person: Person;
}

export const PersonBirthLabel = ({ person }: IProps) => (
  <>{person.gender === 'H' ? 'Né' : 'Née'}</>
);
